import { useState } from "react";
import { Eye, EyeOff, KeyRound } from "lucide-react";

/**
 * Password input with show/hide toggle. Works on mobile, tablet & desktop.
 * Does not change the stored value or auth flow — only the visual mode.
 */
export default function PasswordInput({
  icon: Icon = KeyRound,
  label,
  testid,
  ...rest
}) {
  const [show, setShow] = useState(false);
  return (
    <label className="block">
      {label && (
        <span className="text-[11px] text-[#475467] tracking-wider uppercase font-semibold">
          {label}
        </span>
      )}
      <div className="relative mt-1">
        <Icon size={16} className="absolute left-3 top-3 text-[#98A2B3]" />
        <input
          {...rest}
          type={show ? "text" : "password"}
          className="ph-input w-full pl-10 pr-10 py-2.5 rounded-md text-[14px]"
          data-testid={testid}
        />
        <button
          type="button"
          onClick={() => setShow((v) => !v)}
          aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-[#667085] hover:text-[#9A762F] transition-colors"
          data-testid={testid ? `${testid}-toggle` : undefined}
          tabIndex={-1}
        >
          {show ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </div>
    </label>
  );
}
